import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Globals {
	
	constructor(public router: Router) { }

	/****Select user****/

	userSelect(selectedUser) {
		if (selectedUser == 'TATA AIG Employee') {
			// this.spinner.show();
			// setTimeout(() => {
			// this.spinner.hide();
			// }, 5000);
			this.router.navigateByUrl('/home')
		}
	}
	// edit(id,selectedTab) {
	// 	this.loss_type = selectedTab
	// 	this.editfield = id;
	// }
	// value(_this) {
	// 	this.claimantName = _this.globals.formFieldValue.claimant_name;
	// 	this.claimantNum = _this.globals.formFieldValue.claimant_mobNum;
	// 	this.claimantMail = _this.globals.formFieldValue.claimant_mailId;
	// 	this.repName = _this.globals.formFieldValue.rep_name;
	// 	this.polRepName = _this.globals.formFieldValue.pol_repNum;
	// 	this.polStation = _this.globals.formFieldValue.pol_station;
	// 	this.accDate = _this.globals.formFieldValue.acc_date;
	// 	this.accPlace = _this.globals.formFieldValue.acc_place;
	// 	this.courtNum = _this.globals.formFieldValue.court_verdictNum;
	// 	this.make = _this.globals.formFieldValue.make;
	// 	this.model = _this.globals.formFieldValue.model;
	// 	this.tcNumber = _this.globals.formFieldValue.tc_num;
	// 	this.chassisNumber = _this.globals.formFieldValue.veh_chassis_num;
	// 	this.vechPlateNum = _this.globals.formFieldValue.vechicle_num;
	// }
	// getInputFieldValue(inputFieldValue) {
	// 	this.formFieldValue = inputFieldValue;
	// }
	
	// editfield(_this){
	// this.test.claimant_name = 'claimName'
	// this.test.claimant_mobNum = 'claimNum'
	// this.test.claimant_mailId = 'mailId'
	// this.test.claimant_name = 'repName'
	// this.test.claimant_name = 'repNum'
	// this.test.claimant_name = 'policeStation'
	// this.test.claimant_name = 'accDate'
	// }
}
